import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const SEV_STYLE = { critical: "tag-red", warning: "tag-orange", info: "tag-green" };

export default function AlertsPage() {
  const [alerts, setAlerts] = useState([]);
  const load = () => api.get("/alerts").then(r => setAlerts(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/alerts/${id}/read`); toast.success("Alerte marquée lue"); load();
  };

  return (
    <div className="space-y-8" data-testid="alerts-page">
      <div>
        <p className="eyebrow mb-1">Surveillance</p>
        <h1 className="text-3xl sm:text-4xl font-serif tracking-tight">Alertes ({alerts.filter(a => !a.read).length} non lues)</h1>
      </div>
      <div className="hairline">
        {alerts.length === 0 && (
          <p className="p-10 text-center text-sm text-muted-foreground">Aucune alerte. Les recrawls et vérifications d'expiration tournent en arrière-plan.</p>
        )}
        {alerts.map((a, i) => (
          <div key={a.id} className={`p-5 grid md:grid-cols-[auto_1fr_auto] gap-4 items-start ${i > 0 ? "border-t border-border" : ""} ${a.read ? "opacity-60" : ""}`} data-testid={`alert-${a.id}`}>
            <BellRing className={`w-5 h-5 ${a.severity === "critical" ? "text-[hsl(var(--status-red))]" : a.severity === "warning" ? "text-[hsl(29_87%_50%)]" : "text-[hsl(var(--status-green))]"}`} />
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className={`px-1.5 h-5 text-[10px] font-mono flex items-center rounded-lg ${SEV_STYLE[a.severity] || ""}`}>{a.severity.toUpperCase()}</span>
                <p className="font-mono text-[10px] text-muted-foreground">{a.type} · {new Date(a.created_at).toLocaleString()}</p>
              </div>
              <p className="font-serif text-lg">{a.title}</p>
              <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{a.body}</p>
            </div>
            {!a.read && (
              <Button variant="outline" size="sm" onClick={() => markRead(a.id)} className="rounded-lg" data-testid={`read-alert-${a.id}`}>
                <CheckCircle2 className="w-4 h-4 mr-1" /> Lu
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
